document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', function(event) {
        event.preventDefault(); // Prevent page reload
        
        const formData = new FormData(this);

        fetch('/cart/add.js', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            alert('Product added to cart!'); // Display confirmation
        })
        .catch(error => {
            console.error('Error adding product:', error);
        });
    });
});
